import {
	Button,
	Divider,
	Grid,
	IconButton,
	InputAdornment,
	TextField,
	Typography,
	withStyles,
} from '@material-ui/core';
import { SnackBarVariants } from '@app/app.enum';
import { StyleRules } from '@material-ui/core/styles';
import { History } from 'history';
import * as React from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import { SharedService } from '@app/services/shared.service';
import { AccountLevelEnum } from '@app/app.enum';
import store from '@app/app.store';
import CustomDialogBox from '@app/components/shared/dialog.component';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import withSnackBar from '../core/message.component';
import Axios from 'axios';
import Icon from './icon.component';

const styles: StyleRules = {
	keyInput: {
		fontSize: 16,
		padding: '10px 14px',
	},
	textLabel: {
		fontSize: 18,
	},
};

interface ISecretKeySettingState {
	isProdCredMasked: boolean;
	isTestCredMasked: boolean;
	openConfirmDialog: boolean;
	apiCredsToRegenerate: string;
}

interface ISecretKeySettingProps extends models.ISnackBarFeature {
	appDataToShow: models.IAccountAppResponseVM;
	onApiKeyRegenerated: (app: models.IAccountAppResponseVM) => void;
	accessToken?: string;
	classes: any;
	intl: InjectedIntl;
	history: History;
}
const sharedServive: SharedService = Injector.get(SharedService);
const accountService: AccountService = Injector.get(AccountService);

class SecretKeySettingComponent extends React.Component<ISecretKeySettingProps, ISecretKeySettingState> {
	private apiKeyRef: React.RefObject<{}>;
	private apiSecretRef: React.RefObject<{}>;
	private testApiKeyRef: React.RefObject<{}>;
	private testApiSecretRef: React.RefObject<{}>;
	private isPartnerAccount: boolean;
	constructor(props: ISecretKeySettingProps) {
		super(props);
		this.state = {
			apiCredsToRegenerate: '',
			isProdCredMasked: true,
			isTestCredMasked: true,
			openConfirmDialog: false,
		};

		// This is to have a direct access text fields.
		this.apiKeyRef = React.createRef();
		this.apiSecretRef = React.createRef();
		this.testApiKeyRef = React.createRef();
		this.testApiSecretRef = React.createRef();

		this.isPartnerAccount =
			!props.accessToken && store.getState()?.authentication?.user?.account?.level === AccountLevelEnum.Partner;
	}

	public render() {
		const appDataToShow = this.props.appDataToShow;

		const { classes } = this.props as any;
		const { isProdCredMasked } = this.state;
		const { isTestCredMasked } = this.state;
		const dialogTitle = this.props.intl.formatMessage({
			id: 'app.api-key.regenerate-credentials',
		});
		const dialogDescription = this.props.intl.formatMessage({
			id: 'app.api-key.credentials-regenerate-confirm-message',
		});
		return (
			<React.Fragment>
				<Grid container={true} spacing={2}>
					<Grid item={true} lg={12} md={12} sm={12} xs={12}>
						<Grid container={true} spacing={2}>
							<Grid item={true} lg={12} md={12} sm={12} xs={12}>
								<Grid container={true} spacing={2} direction='column'>
									<Grid item={true} className='pb-0'>
										<Typography gutterBottom={true} component='h5' className={classes.textLabel}>
											{this.props.intl.formatMessage({
												id: 'app.api-key.prod-credentials',
											})}
										</Typography>
									</Grid>
									<Grid item={true} className='pt-0'>
										<Typography gutterBottom={true} component='h5' className={classes.textLabel}>
											{this.props.intl.formatMessage({
												id: 'app.api-key.api-key',
											})}
										</Typography>
										<TextField
											variant='outlined'
											className='width-100 no-select'
											type={'text'}
											value={appDataToShow.apiKey}
											inputRef={this.apiKeyRef}
											InputProps={{
												classes: {
													input: classes.keyInput,
												},
												endAdornment: (
													<InputAdornment position='end'>
														<IconButton
															onClick={() => this.copyToClipboard(appDataToShow.apiKey)}
															disabled={this.isPartnerAccount}
														>
															<Icon name='file-copy' />
														</IconButton>
													</InputAdornment>
												),
												readOnly: true,
											}}
										/>
									</Grid>
									<Grid item={true}>
										<Typography gutterBottom={true} component='h5' className={`${classes.textLabel} mt-1`}>
											{this.props.intl.formatMessage({
												id: 'app.api-key.api-secret',
											})}
										</Typography>
										<TextField
											variant='outlined'
											className='width-100 no-select'
											type={isProdCredMasked ? 'password' : 'text'}
											value={appDataToShow.apiSecret}
											inputRef={this.apiSecretRef}
											InputProps={{
												classes: {
													input: classes.keyInput,
												},
												endAdornment: (
													<InputAdornment position='end'>
														<IconButton
															onClick={() => this.copyToClipboard(appDataToShow.apiSecret)}
															disabled={this.isPartnerAccount}
														>
															<Icon name='file-copy' />
														</IconButton>
													</InputAdornment>
												),
												readOnly: true,
											}}
										/>
									</Grid>
									{!this.isPartnerAccount && (
										<Grid container={true} alignItems='center' direction='row' spacing={3} justifyContent='center'>
											<Grid item={true}>
												<Button variant='outlined' color='primary' onClick={this.toggleProdCredMask}>
													{isProdCredMasked
														? this.props.intl.formatMessage({
																id: 'app.api-key.show-credentials',
														  })
														: this.props.intl.formatMessage({
																id: 'app.api-key.hide-credentials',
														  })}
												</Button>
											</Grid>
											<Grid item={true}>
												<Button
													color='secondary'
													onClick={() => {
														this.openConfirmDialog(appDataToShow.apiKey);
													}}
												>
													{this.props.intl.formatMessage({
														id: 'app.api-key.regenerate-credentials',
													})}
												</Button>
											</Grid>
										</Grid>
									)}
									<Divider className='mt-2 mb-1' />
									<Grid item={true}>
										<Grid container={true} justifyContent='center' spacing={2}>
											<Grid item={true} xs={12} className='pb-0'>
												<Typography component='h5' gutterBottom={true} className={classes.textLabel}>
													{this.props.intl.formatMessage({
														id: 'app.api-key.test-credentials',
													})}
												</Typography>
											</Grid>
											<Grid item={true} xs={12} className='pt-0 pl-1'>
												<Typography gutterBottom={true} variant='caption' color='inherit'>
													{this.props.intl.formatMessage({
														id: 'app.api-key.test-info',
													})}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
									<Grid item={true} className='pt-0'>
										<Typography gutterBottom={true} component='h5' className={classes.textLabel}>
											{this.props.intl.formatMessage({
												id: 'app.api-key.api-key',
											})}
										</Typography>
										<TextField
											variant='outlined'
											className='width-100 no-select'
											type={'text'}
											value={appDataToShow.testApiKey}
											inputRef={this.testApiKeyRef}
											InputProps={{
												classes: {
													input: classes.keyInput,
												},
												endAdornment: (
													<InputAdornment position='end'>
														<IconButton
															onClick={() => this.copyToClipboard(appDataToShow.testApiKey)}
															disabled={this.isPartnerAccount}
														>
															<Icon name='file-copy' />
														</IconButton>
													</InputAdornment>
												),
												readOnly: true,
											}}
										/>
									</Grid>
									<Grid item={true}>
										<Typography gutterBottom={true} component='h5' className={`${classes.textLabel} mt-1`}>
											{this.props.intl.formatMessage({
												id: 'app.api-key.api-secret',
											})}
										</Typography>
										<TextField
											variant='outlined'
											className='width-100 no-select'
											type={isTestCredMasked ? 'password' : 'text'}
											value={appDataToShow.testApiSecret}
											inputRef={this.testApiSecretRef}
											InputProps={{
												classes: {
													input: classes.keyInput,
												},
												endAdornment: (
													<InputAdornment position='end'>
														<IconButton
															onClick={() => this.copyToClipboard(appDataToShow.testApiSecret)}
															disabled={this.isPartnerAccount}
														>
															<Icon name='file-copy' />
														</IconButton>
													</InputAdornment>
												),
												readOnly: true,
											}}
										/>
									</Grid>
									{!this.isPartnerAccount && (
										<Grid container={true} alignItems='center' direction='row' spacing={3} justifyContent='center'>
											<Grid item={true}>
												<Button variant='outlined' color='primary' onClick={this.toggleTestCredMask}>
													{isTestCredMasked
														? this.props.intl.formatMessage({
																id: 'app.api-key.show-credentials',
														  })
														: this.props.intl.formatMessage({
																id: 'app.api-key.hide-credentials',
														  })}
												</Button>
											</Grid>
											<Grid item={true}>
												<Button
													color='secondary'
													onClick={() => {
														this.openConfirmDialog(appDataToShow.testApiKey);
													}}
												>
													{this.props.intl.formatMessage({
														id: 'app.api-key.regenerate-credentials',
													})}
												</Button>
											</Grid>
										</Grid>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>

				<CustomDialogBox
					open={this.state.openConfirmDialog}
					dialogTitle={dialogTitle}
					dialogDescription={dialogDescription}
					closeCustomDialog={this.closeConfirmDialog}
					fullWidth={true}
				/>
			</React.Fragment>
		);
	}

	// In the below two functions 'e' param is necessary as this function is being used as onClick handler also.
	// therefore, TypeScript complains that 1st param show be e.
	private toggleProdCredMask = (e: React.MouseEvent, showText: boolean = null) => {
		this.setState((prevState) => ({
			isProdCredMasked: showText || !prevState.isProdCredMasked,
		}));
	};

	private toggleTestCredMask = (e: React.MouseEvent, showText: boolean = null) => {
		this.setState((prevState) => ({
			isTestCredMasked: showText == null ? !prevState.isTestCredMasked : showText,
		}));
	};

	private copyToClipboard = async (textToCopy: string) => {
		await navigator.clipboard.writeText(textToCopy);
		const snackBarMessage = this.props.intl.formatMessage({
			id: 'app.api-key.copied-to-clipboard',
		});

		this.props.openSnackBar(snackBarMessage);
	};

	private generateKey = async (apiKey: string) => {
		const snackBarMessage = this.props.intl.formatMessage({
			id: 'app.api-key.credentials-regenerated',
		});

		try {
			const app = await accountService.regenerateApiCreds(apiKey, this.props.accessToken);
			const userData = accountService.getUserData();
			if (userData) {
				userData.apps.forEach((a: any) => {
					if (a.apiKey === apiKey) {
						a.apiKey = app.apiKey;
						a.apiSecret = app.apiSecret;
					} else if (a.testApiKey === apiKey) {
						a.testApiKey = app.apiKey;
						a.testApiSecret = app.apiSecret;
					}
				});
				accountService.setUserData(userData);
			}

			const currentApp = this.props.appDataToShow;

			if (currentApp.apiKey === apiKey) {
				currentApp.apiKey = app.apiKey;
				currentApp.apiSecret = app.apiSecret;
			} else if (currentApp.testApiKey === apiKey) {
				currentApp.testApiKey = app.apiKey;
				currentApp.testApiSecret = app.apiSecret;
			}
			this.props.onApiKeyRegenerated(currentApp);
			this.props.openSnackBar(snackBarMessage);
		} catch (error) {
			if (!Axios.isCancel(error)) {
				this.props.openSnackBar(sharedServive.parseError(error.data), SnackBarVariants.Error);
			}
		}
	};

	private closeConfirmDialog = (title?: string, isCancel?: boolean) => {
		if (!isCancel) {
			this.generateKey(this.state.apiCredsToRegenerate);
		}
		this.setState({
			openConfirmDialog: false,
		});
	};

	private openConfirmDialog = (apiKey: string) => {
		this.setState({
			apiCredsToRegenerate: apiKey,
			openConfirmDialog: true,
		});
	};
}
export default withSnackBar(withStyles(styles)(injectIntl(SecretKeySettingComponent)));



// WEBPACK FOOTER //
// ./src/components/shared/secret-key-setting.component.tsx